import React, { useEffect, useRef, useState } from "react";
import { Button } from "../components/Elements";
import Filters from "../components/OrderReports/Filters";
import ReportTable from "../components/OrderReports/ReportTable";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { buttonTexts } from "../../constants/texts/buttonTexts";
import { useSelector } from "react-redux";
import { exportExcelHelper } from "../../common/helpers/exportExcelHelper";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";
import { UserOperationTypes } from "../../common/types/AuthorizationProps";
import { getUserIdentity } from "../../common/helpers/authorizationHelper";
import commonNetwork from "../../common/api/commonNetwork";

const initialValues = {
  startDate: "",
  endDate: "",
  customerName: "",
  startAmount: "0",
  endAmount: "0",
  sendType: 0,
  paymentStatus: 0,
  linkStartDate: "",
  linkEndDate: "",
  erpSyncType: 0,
  bankId: 0,
  customerId: 0,
  cityId: 0,
  orderResource: 0,
  cardFirstPart: "",
  cardLastPart: "",
  orderCode: "",
  installmentType: 0,
  taxCode: "",
  authCode: "",
  createUserId: ["BAYİ/MÜŞTERİ", "ALTBAYİ", "MÜŞTERİ TEMSİLCİSİ"].includes(getUserIdentity())
    ? parseInt(localStorage.getItem("_us_d") || "0", 10)
    : null,
  currencyId: 0,
  isTest: false,
  invoiceNumber: "",
  parentUserId: 0,
};

export default function OrderReport() {
  usePermissionCheck(UserOperationTypes["İşlem Listesi"], "Tahsilat Hareketlerini görüntüleme izni yok");
  const [filtersIsOpen, setFiltersIsOpen] = useState(true);
  const [tableDetail, setTableDetail] = useState(false);
  const [headCells, setHeadCells] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);
  const [isDealer, setIsDealer] = useState(false);

  // Pagination için
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [requestParameters, setRequestParameters] = useState(initialValues);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    handleUserIdentity();
  }, []);

  const formFilterRef = useRef();
  const reportTableRef = useRef();

  const { reports } = useSelector((state) => state.orderReport);

  const handleShowDetailChange = (value) => {
    setTableDetail(value);
  }

  const exportToExcelClick = async () => {
    setExcelLoading(true);
    try {
      if (selectAll) {
        const parameters = {
          startDate: requestParameters.startDate,
          endDate: requestParameters.endDate,
          customerName: requestParameters.customerName,
          startAmount: requestParameters.startAmount || "0",
          endAmount: requestParameters.endAmount || "0",
          sendType: requestParameters.sendType,
          paymentStatus: requestParameters.paymentStatus || 0,
          linkStartDate: requestParameters.linkStartDate,
          linkEndDate: requestParameters.linkEndDate,
          erpSyncType: requestParameters.erpSyncType,
          bankId: requestParameters.bankId,
          customerId: requestParameters.customerId,
          cityId: requestParameters.cityId,
          orderResource: requestParameters.orderResource,
          cardFirstPart: requestParameters.cardFirstPart,
          cardLastPart: requestParameters.cardLastPart,
          orderCode: requestParameters.orderCode,
          installmentType: requestParameters.installmentType || 0,
          taxCode: requestParameters.taxCode,
          authCode: requestParameters.authCode,
          createUserId: (isDealer ? localStorage.getItem("_us_d") : requestParameters.createUserId) || 0,
          currencyId: requestParameters.currencyId,
          isTest: requestParameters.isTest,
          invoiceNumber: requestParameters.invoiceNumber || "",
          parentUserId: requestParameters.parentUserId
        };

        // 3. parametre true (isDocumentDownload) olarak gönderiliyor
        const result = await commonNetwork.post("/payment/exportOrders", parameters, true);

        if (result && result.data) {
          const href = URL.createObjectURL(result.data);
          const link = document.createElement('a');

          const nowDate = new Date();
          const dateStr = `${nowDate.getDate()}_${nowDate.getMonth() + 1}_${nowDate.getFullYear()}`;

          link.href = href;
          link.setAttribute('download', `${dateStr}-Tahsilat_Hareketleri.xlsx`);
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);

          if (reportTableRef?.current) {
            reportTableRef.current.clearSelected();
          }
        } else {
          toast.error("Excel dosyası indirilemedi.");
        }
      } else {
        // Sayfada seçili kayıtlar varsa mevcut helper üzerinden indirme
        await exportExcelHelper(reports, "id", reportTableRef, headCells, "Tahsilat_Hareketleri");
      }
    } catch (error) {
      toast.error("Excel aktarımı sırasında bir hata oluştu: " + error);
    } finally {
      setExcelLoading(false);
      setSelectAll(false);
    }
  };

  const handleHeadCells = (values) => {
    setHeadCells(values);
  }

  const handleUserIdentity = () => {
    switch (getUserIdentity()) {
      case "BAYİ/MÜŞTERİ":
      case "ALTBAYİ":
      case "MÜŞTERİ TEMSİLCİSİ":
        setIsDealer(true);
        break;
      default:
        setIsDealer(false);
        break;
    }
  }

  return (
    <div className="w-full">
      <PageTitle title={pageTitleTexts.orderReport} />

      <div className="px-4 pt-2 flex flex-row items-center justify-between space-y-2">
        <div className="flex flex-row items-center">
          <img src={"/icons/islem-raporu-dark.svg"} className="h-6 w-6 black" />
          <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
            Tahsilat Hareketleri
          </span>
        </div>

        <div className=" flex flex-row justify-end items-center px-2">
          <Button
            size="xs"
            hover="gray"
            color="gray"
            callback={() => setFiltersIsOpen(!filtersIsOpen)}
          >
            <span className="mr-3">{buttonTexts.filterOpen}</span>
            <img src="/icons/filter.svg" alt="filter" />
          </Button>
        </div>
      </div>

      <Filters
        ref={formFilterRef}
        isOpen={filtersIsOpen}
        setFiltersIsOpen={setFiltersIsOpen}
        onShowDetailChange={handleShowDetailChange}
        page={page}
        pageSize={pageSize}
        setRequestParameters={setRequestParameters} />
      <div className="mr-4 flex justify-end">
        <Button
          color="primary"
          hover="primary"
          size="xs"
          callback={() => exportToExcelClick()}
          loading={excelLoading}
          disabled={excelLoading}
        >
          <img src="/icons/download.svg" alt="pushToExcel" />
          <span className='ml-3'>{buttonTexts.exportToExcel}</span>
        </Button>
      </div>
      <ReportTable
        formFilterRef={formFilterRef}
        showTableDetail={tableDetail}
        getHeadCells={handleHeadCells}
        reportTableRef={reportTableRef}
        page={page}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
        requestParameters={requestParameters}
        setSelectAll={setSelectAll} />
    </div>
  );
}
